import React, { useState } from "react";
import { useLookupByName } from "../hooks/useLookupByName";

export function NameSearch({ t }) {
  const [query,    setQuery]    = useState("");
  const [results,  setResults]  = useState([]);
  const [searched, setSearched] = useState(false);
  const [openRows, setOpenRows] = useState({});
  const { lookupByName } = useLookupByName();

  const go = async () => { if (query.trim().length < 2) return; setResults(await lookupByName(query)); setSearched(true); };
  const clear = () => { setQuery(""); setResults([]); setSearched(false); };
  const toggleRow = (key) => {
    setOpenRows(prev => ({ ...prev, [key]: !prev[key] }));
  };


  function Highlight({ text }) {
    if (!text) return "—";
    const q = query.trim().toUpperCase();
    const idx = text.toUpperCase().indexOf(q);
    if (idx === -1) return text;
    return <>{text.slice(0, idx)}<mark className="hl">{text.slice(idx, idx + q.length)}</mark>{text.slice(idx + q.length)}</>;
  }

  return (
    <div>
      <div className="form-group">
        <label className="field-label">{t("business_name_label")}</label>
        <div className="input-wrap">
          <input className="field" value={query}
            onChange={e => { setQuery(e.target.value); setSearched(false); }}
            onKeyDown={e => e.key === "Enter" && go()}
            placeholder={t("name_search_placeholder")}
            autoFocus
          />
          {query && <button className="field-clear" onClick={clear}>✕</button>}
        </div>
        <div style={{ fontSize:12, color:"var(--text-faint)", fontFamily:"IBM Plex Mono, monospace", marginTop:6 }}>
          {t("name_search_hint")}
        </div>
      </div>
      <button className="btn btn-primary btn-full" onClick={go} disabled={query.trim().length < 2}>{t("search_fbr")}</button>

      {searched && results.length === 0 && (
        <div className="db-result db-miss" style={{ marginTop:20 }}>
          <div className="db-result-status">
            <span className="db-dot db-dot-miss" />
            <span className="db-result-label">{t("no_matches_found")}</span>
          </div>
          <p className="db-miss-msg">{t("no_match_msg").replace("{query}", query)}</p>
        </div>
      )}

      {searched && results.length > 0 && (
        <div style={{ marginTop:20 }}>
          {results.map((r, i) => {
            const key = r.t; // use NTN as unique key
            const open = openRows[key] || false;
            return (
              <div key={key} className={`name-row ${open ? "name-row-open" : ""}`}>
                <button className="name-row-header" onClick={() => toggleRow(key)}>
                  <div className="name-row-left">
                    <span className="name-row-bn"><Highlight text={r.bn || r.nm} /></span>
                    {r.bn && r.nm && r.bn !== r.nm && <span className="name-row-nm"><Highlight text={r.nm} /></span>}
                  </div>
                  <div className="name-row-right">
                    <span className="name-row-ntn">{r.t}</span>
                    <span className="name-row-chevron">{open ? "▲" : "▼"}</span>
                  </div>
                </button>
                {open && (
                  <div className="name-row-detail">
                    {/* row details */}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
